<template>
  <div class="drag-resize__wrap">
    <div
      v-for="item in handlers"
      :key="item"
      :class="item"
      class="handler"
      @mousedown.stop="onMouseDown(item, $event)"
    ></div>
    <!-- <div class="handler top" @mousedown.stop="onMouseDown('top',$event)"></div>
    <div class="handler bottom" @mousedown.stop="onMouseDown('bottom',$event)"></div>
    <div class="handler left" @mousedown.stop="onMouseDown('left',$event)"></div>
    <div class="handler right" @mousedown.stop="onMouseDown('right',$event)"></div>
    <div class="handler top-left" @mousedown.stop="onMouseDown('top-left',$event)"></div>
    <div class="handler top-right" @mousedown.stop="onMouseDown('top-right',$event)"></div>
    <div class="handler bottom-left" @mousedown.stop="onMouseDown('bottom-left',$event)"></div>
    <div class="handler bottom-right" @mousedown.stop="onMouseDown('bottom-right',$event)"></div> -->
  </div>
</template>

<script>
export default {
  name: 'drag-resize',
  props: {
    left: Number,
    top: Number,
    width: Number,
    height: Number
  },
  data () {
    return {
      clientX: 0,
      clientY: 0,
      originTop: 0,
      originLeft: 0,
      originWidth: 0,
      originHeight: 0,
      type: '',
      handlers: ['top', 'bottom', 'left', 'right', 'top-left', 'top-right', 'bottom-left', 'bottom-right']
    }
  },
  methods: {
    onMouseDown (type, e) {
      this.type = type
      this.clientX = e.clientX
      this.clientY = e.clientY
      this.originTop = this.top
      this.originLeft = this.left
      this.originWidth = this.width
      this.originHeight = this.height
      document.addEventListener('mousemove', this.onMouseMove)
      document.addEventListener('mouseup', this.onMouseUp)
    },
    onMouseMove (e) {
      let _diffX = e.clientX - this.clientX
      let _diffY = e.clientY - this.clientY
      let width = 0
      let height = 0
      let left = 0
      let top = 0
      if (this.type.indexOf('top') !== -1) {
        top = _diffY
        height = _diffY * -1
      }
      if (this.type.indexOf('bottom') !== -1) {
        height = _diffY
      }
      if (this.type.indexOf('left') !== -1) {
        left = _diffX
        width = _diffX * -1
      }
      if (this.type.indexOf('right') !== -1) {
        width = _diffX
      }
      this.$emit('resize', this.originTop + top, this.originLeft + left, this.originWidth + width, this.originHeight + height)
    },
    onMouseUp (e) {
      this.removeEvent()
    },
    removeEvent () {
      document.removeEventListener('mousemove', this.onMouseMove)
      document.removeEventListener('mouseup', this.onMouseUp)
    }
  },
  beforeDestroy () {
    this.removeEvent()
  }
}
</script>

<style lang="less" scoped>
@lineWidth: 4px;
@rectWidth: 16px;
.drag-resize__wrap {
  z-index: 99;
  .handler {
    position: absolute;
    user-select: none;
    &.top {
      left: -2px;
      right: -2px;
      top: -2px;
      height: @lineWidth;
      cursor: n-resize;
      z-index: 8;
    }
    &.bottom {
      left: -2px;
      right: -2px;
      bottom: -2px;
      height: @lineWidth;
      cursor: s-resize;
      z-index: 8;
    }
    &.left {
      left: -2px;
      width: @lineWidth;
      top: -2px;
      bottom: -2px;
      cursor: w-resize;
      z-index: 8;
    }
    &.right {
      right: -2px;
      width: @lineWidth;
      top: -2px;
      bottom: -2px;
      cursor: e-resize;
      z-index: 8;
    }
    &.top-left {
      top: -2px;
      left: -2px;
      width: @rectWidth;
      height: @rectWidth;
      z-index: 9;
      cursor: nw-resize;
    }
    &.top-right {
      top: -2px;
      right: -2px;
      width: @rectWidth;
      height: @rectWidth;
      z-index: 9;
      cursor: ne-resize;
    }
    &.bottom-left {
      bottom: -2px;
      left: -2px;
      width: @rectWidth;
      height: @rectWidth;
      z-index: 9;
      cursor: sw-resize;
    }
    &.bottom-right {
      bottom: -2px;
      right: -2px;
      width: @rectWidth;
      height: @rectWidth;
      z-index: 9;
      cursor: se-resize;
    }
  }
}
</style>
